Ext.define('SA.view.color.HexField', {
    alias: 'widget.hex-field',
    extend: 'SA.view.TextField',

    cls: 'sa-color-window-hex-field',
    fieldLabel: '#',
    height: 28,
    labelSeparator: '',
    labelWidth: 18,
    maskRe: /[a-f\d]/i,
    maxLength: 12, 
    stripCharsRe: /[^a-fA-F\d]+/g,
    width: 90,

    afterRender() {
        this.callParent();

        this.inputEl.set({spellcheck: false});
    },

    beforeBlur() {
        this.callParent();

        this.setValue(this.color.getColor());
    },

    getRawColor() {
        var value = this.getValue();

        if (value.length > 6) {
            value = value.slice(0, 6);
        }

        while (value.length < 6) {
            value += '0';
        }

        return value;
    },

    onChange() {
        var value, color;

        this.callParent(arguments);

        value = this.getRawColor();

        if (value !== this.color.getColor()) {
            color = this.color = new SA.model.color.Color({color: value});

            this.fireEvent('select:color', this, color);
        }
    },

    setColor(color) {
        var oldColor = this.color,
            newValue = color.getColor();

        if (!oldColor || oldColor.getColor() !== newValue) {
            this.color = color;

            this.setValue(newValue);
        }
    }
});